import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router";
import { services } from "../../api";
import calIcon from "../../img/cal_icon.png";
import "react-calendar/dist/Calendar.css";
import "../../stylesheets/faultForms.css";
import { cloneDeep, isEmpty } from "lodash";
import "react-datepicker/dist/react-datepicker.css";
import "react-datetime/css/react-datetime.css";
import Datetime from "react-datetime";
import moment from "moment";
import { GetStatus } from "./GetStatus";
import { Loader } from "../Utils/Loader";
import { validateEmail } from "../Utils/Util";
import momenttimezone from "moment-timezone";

export const FaultForm = () => {
  const [attachmentFile, setAttachmentFile] = useState(undefined);
  const history = useHistory();
  const { loader } = useSelector((state) => state.HeaderReducer);
  const { faultType } = useParams();

  const [payload, setPayload] = useState({
    date: momenttimezone(new Date())
      .tz("Europe/London")
      .format("DD-MM-YYYY HH:mm"),
    suggestions: "",
    stationId: "",
    subStationId: "",
    description: "",
    isReported: 1,
    isUpdated: 1,
    name: "",
    mobileNumber: "",
    email: "",
    isMobileSelected: false,
    isEmailSelected: false,
  });
  const [stationList, setStationList] = useState([]);
  const [validationCheck, setValidationCheck] = useState({
    stationId: false,
    subStationId: false,
    name: false,
    description: false,
    suggestions: false,
    email: false,
  });

  const [isShowErrorModal, setIsShowErrorModal] = useState(false);
  const [responseData, setResponseData] = useState();
  const formReducer = useSelector((state) => state.FaultFormReducer);
  const userData = useSelector((state) => state.usersReducers);
  const { getAllStationList = [] } = formReducer;

  let formType =
    faultType == "station"
      ? "cff"
      : faultType == "train"
      ? "ctf"
      : faultType == "suggestions"
      ? "cs"
      : faultType == "getstatus"
      ? "gs"
      : undefined;

  useEffect(() => {
    if (getAllStationList.length > 0) {
      setStationList(getAllStationList);
    }
  }, [getAllStationList]);

  useEffect(() => {
    if (formType) {
      if (formType == "ctf" || formType == "cff") {
        services.getStationList(`faultsubmissions?tab=${formType}`, "get");
      }
    } else {
      history.push("/");
    }
  }, []);

  const onChangeHandler = (e, value, type = "") => {
    let payloadTemp = cloneDeep(payload);
    let validationCheckTemp = cloneDeep(validationCheck);

    if (type == "file") {
      setAttachmentFile(e.target.files);
    } else if (e.target.id === "isReported" || e.target.id === "isUpdated") {
      payloadTemp[e.target.id] = value;
      if (e.target.id === "isUpdated" && value == 0) {
        delete validationCheckTemp.email;
        delete validationCheckTemp.mobileNumber;
      }
    } else if (
      e.target.id === "mobileNumberCheckBox" ||
      e.target.id === "emailCheckBox"
    ) {
      payloadTemp.email = "";
      payloadTemp.mobileNumber = "";
      if (e.target.id === "mobileNumberCheckBox") {
        validationCheckTemp.email = false;
        payloadTemp.isMobileSelected = true;
        payloadTemp.isEmailSelected = false;
      } else {
        payloadTemp.isEmailSelected = true;
        payloadTemp.isMobileSelected = false;
      }
    } else if (e.target.id === "mobileNumber") {
      if (!isNaN(e.target.value)) {
        payloadTemp[e.target.id] = e.target.value;
      }
    } else {
      payloadTemp[e.target.id] = e.target.value;
    }
    setValidationCheck(validationCheckTemp);
    setPayload(payloadTemp);
  };

  const onSubmitHandler = async () => {
    let validationCheckTemp = cloneDeep(validationCheck);
    const formData = new FormData();
    let payloadTemp = cloneDeep(payload);

    if (formType == "cff") {
      delete validationCheckTemp.suggestions;
      delete validationCheckTemp.subStationId;
    } else if (formType == "ctf") {
      delete validationCheckTemp.suggestions;
    } else if (formType == "cs") {
      delete validationCheckTemp.stationId;
      delete validationCheckTemp.subStationId;
      delete validationCheckTemp.description;
    }

    Object.keys(validationCheckTemp).map((key) => {
      if (key == "email") {
        validationCheckTemp[key] = payloadTemp.isEmailSelected
          ? !validateEmail(payload.email)
          : false;
      } else {
        if (!payloadTemp[key]) {
          validationCheckTemp[key] = true;
        } else {
          validationCheckTemp[key] = false;
        }
      }
    });

    if (attachmentFile && attachmentFile.length > 0) {
      let sizeInMB = (attachmentFile[0].size / (1024 * 1024)).toFixed(2);

      if (sizeInMB > 2) {
        validationCheckTemp.fileSize = true;
      } else {
        validationCheckTemp.fileSize = false;
      }
    }

    if (
      payloadTemp.isUpdated == 1 &&
      !(payloadTemp.mobileNumber || payloadTemp.email)
    ) {
      setValidationCheck(validationCheckTemp);

      setIsShowErrorModal(true);
      return;
    } else {
      validationCheckTemp.name = false;
    }

    setValidationCheck(validationCheckTemp);

    if (
      !Object.keys(validationCheckTemp).some((el) => validationCheckTemp[el])
    ) {
      delete payloadTemp.isEmailSelected;
      delete payloadTemp.isMobileSelected;

      let stationName = stationList.filter(
        (station) => station.station_id == payloadTemp.stationId
      );
      let dmStationName = stationList.filter(
        (station) => station.station_id == payloadTemp.subStationId
      );

      payloadTemp["stationName"] = stationName[0]?.station_name;
      payloadTemp["emStationName"] = stationName[0]?.station_name;
      payloadTemp["dmStationName"] = dmStationName[0]?.station_name;

      if (formType == "cff") {
        delete payloadTemp.subStationId;
        delete payloadTemp.dmStationName;
        delete payloadTemp.emStationName;
        delete payloadTemp.suggestions;
      } else if (formType == "ctf") {
        delete payloadTemp.suggestions;
        delete payloadTemp.stationName;
      } else if (formType == "cs") {
        delete payloadTemp.stationId;
        delete payloadTemp.subStationId;
        delete payloadTemp.dmStationName;
        delete payloadTemp.emStationName;
        delete payloadTemp.stationName;
        delete payloadTemp.description;
        delete payloadTemp.isReported;
      }

      Object.keys(payloadTemp).map((key) => {
        formData.append(key, payloadTemp[key]);
      });

      if (attachmentFile && attachmentFile.length) {
        formData.append("attachmentFile", attachmentFile[0]);
      }
      let data = await services.submitFaultForms(
        `faultsubmissions?tab=${formType}`,
        "post",
        formData
      );
      if (data.statusCode == 200) {
        let file = document.getElementById("file");
        if (file) {
          document.getElementById("file").value = "";
        }
        setAttachmentFile(undefined);
      }
      setResponseData(data);
    }
  };

  const dateChangeHandler = (e) => {
    let payloadTemp = cloneDeep(payload);
    payloadTemp.date = moment(e).format("DD-MM-YYYY HH:mm");
    setPayload(payloadTemp);
  };

  const disableFutureDt = (current) => {
    let today = moment();
    return current.isBefore(today);
  };

  const onClearHandler = () => {
    let payloadTemp = cloneDeep(payload);
    payloadTemp.stationId = "";
    payloadTemp.subStationId = "";
    payloadTemp.date = momenttimezone(new Date())
      .tz("Europe/London")
      .format("DD-MM-YYYY HH:mm");
    payloadTemp.description = "";
    payloadTemp.name = "";
    payloadTemp.isReported = 1;
    payloadTemp.isUpdated = 1;
    payloadTemp.mobileNumber = "";
    payloadTemp.email = "";
    payloadTemp.suggestions = "";
    payloadTemp.isMobileSelected = false;
    payloadTemp.isEmailSelected = false;
    setPayload(payloadTemp);
    setValidationCheck({
      stationId: false,
      subStationId: false,
      name: false,
      description: false,
      suggestions: false,
      email: false,
    });

    // setAttachmentFile(undefined)
    let file = document.getElementById("file");
    if (file) {
      document.getElementById("file").value = "";
    }
  };

  const onResponeModalHandler = () => {
    setResponseData({});
    onClearHandler();
  };

  const removeFileHandler = () => {
    let file = document.getElementById("file");
    if (file) {
      document.getElementById("file").value = "";
    }
    setAttachmentFile(undefined);
  };

  if (loader) {
    return <Loader />;
  } 
  // else if (!userData.isAuthorized) {
  //   return <div className="not-page">User Not Authorized</div>;
  // } 
  else if (formType == "gs") {
    return <GetStatus />;
  }
  return (
    <div
      className={
        formType == "cs"
          ? "form-container getSugg-form four-form"
          : "form-container four-form"
      }
    >
      <div className="container">
        <form autoComplete="off">
          {formType == "cs" ? (
            <div className="row m-b-5">
              <div className="input-field col s12">
                <small className="red-text f-16 pull-right mandatory">*</small>
                <textarea
                  maxLength="500"
                  onChange={onChangeHandler}
                  value={payload.suggestions}
                  name="suggestions"
                  id="suggestions"
                  className="browser-default p-10 c-textarea form-description"
                  placeholder="Enter suggestions..."
                ></textarea>
                <small>
                  <i>
                    (We welcome your suggestions to help us improve our
                    services) (Maximum 500 character)
                  </i>
                </small>
                {validationCheck.suggestions && (
                  <span className="error-message">Please enter suggestion</span>
                )}
              </div>
            </div>
          ) : (
            <>
              <div className="row m-b-5">
                <div className="input-field col-lg-6 col-md-6 col-sm-6 col-12 s12 m6">
                  <i className="prefix">
                    <img className="cal-icon" src={calIcon} alt="cal" />
                  </i>
                  <Datetime
                    className="calender-input"
                    timeFormat="HH:mm"
                    dateFormat="DD-MM-YYYY"
                    onChange={dateChangeHandler}
                    value={payload.date}
                    isValidDate={disableFutureDt}
                    locale="Europe/London"
                  />
                </div>
                <div className="input-field col-lg-6 col-md-6 col-sm-6 col-12 s12 m6">
                  <select
                    className="browser-default"
                    name="stationId"
                    id="stationId"
                    onChange={(e) => onChangeHandler(e)}
                    value={payload.stationId}
                  >
                    <option value="" disabled>
                      {formType == "cff"
                        ? "Station"
                        : "Where did you board the TransPennine Service?"}
                    </option>
                    {stationList.map((station) => (
                      <option
                        key={station.station_id}
                        value={station.station_id}
                      >
                        {station.station_name}
                      </option>
                    ))}
                  </select>
                  {validationCheck.stationId && (
                    <span className="error-message">
                      {formType == "cff"
                        ? "Please select the staion name."
                        : "Please select the Staion name where you got on."}
                    </span>
                  )}
                </div>
                <div className="col-lg-6 col-md-6 col-sm-6 col-0"></div>
                {formType == "ctf" ? (
                  <div className="input-field col-lg-6 col-md-6 col-sm-6 col-0 s12 m6 m-margin">
                    <select
                      className="browser-default"
                      name="subStationId"
                      id="subStationId"
                      onChange={(e) => onChangeHandler(e)}
                      value={payload.subStationId}
                    >
                      <option value="" disabled>
                        Where did you get off the TransPennine Service?
                      </option>
                      {stationList.map((station) => (
                        <option
                          key={station.station_id}
                          value={station.station_id}
                        >
                          {station.station_name}
                        </option>
                      ))}
                    </select>
                    {validationCheck.subStationId && (
                      <span className="error-message">
                        Please select the Staion name where you got off.
                      </span>
                    )}
                  </div>
                ) : (
                  <React.Fragment />
                )}
                <div className="input-field desc-section col-12 s12">
                  <textarea
                    value={payload.description}
                    className="form-description p-10"
                    name="details"
                    id="description"
                    placeholder="Description"
                    maxLength="500"
                    onChange={onChangeHandler}
                  ></textarea>
                  {formType === "ctf" ? (
                    <small>
                      <i>
                        (Please include any relevant seat and carriage numbers
                        (seat number is located at end corner of the seat and
                        carriage number is located above the door at the end of
                        the carriage)
                        {"Maximum 500 characters"}
                      </i>
                    </small>
                  ) : (
                    <small>
                      <i>
                        (Please specify the location for example platform
                        number)
                        {"Maximum 500 characters"}
                      </i>
                    </small>
                  )}
                  {validationCheck.description && (
                    <span className="error-message description-error">
                      Please enter the details of the fault.
                    </span>
                  )}
                </div>
              </div>
              <div id="image-holder"></div>

              <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 file-upload">
                  <div
                    className="fileinput m-t-10 fileinput-new"
                    //  data-provides="fileinput"
                  >
                    <span className="theme-btn light-blue darken-3 btn btn-primary btn-file m-r-10 waves-effect">
                      <span className="fileinput-new">Add a photo</span>{" "}
                      {/* <span className="fileinput-exists">Change</span> */}
                      <input type="hidden" value="" name="" />
                      <input
                        className="hidden-input fault-photo"
                        onChange={(e, value) =>
                          onChangeHandler(e, value, "file")
                        }
                        type="file"
                        id="file"
                        name="file"
                        // value={attachmentFile}
                        //  accept="image/*,video/*"
                        //accept="image/png, image/jpeg"
                        accept="image/*"
                        // capture="environment"
                      />
                    </span>
                    {attachmentFile && attachmentFile.length > 0 && (
                      <span className="fileinput-filename">
                        {attachmentFile[0].name}
                      </span>
                    )}
                    {attachmentFile && attachmentFile.length > 0 && (
                      <div
                        className="close fileinput-exists"
                        data-dismiss="fileinput"
                        onClick={() => removeFileHandler()}
                      >
                        ×
                      </div>
                    )}
                    {validationCheck.fileSize && (
                      <span className="error-message file-upload-error">
                        File size cannot be greater than 2MB.
                      </span>
                    )}
                  </div>
                  {/* <!--   <button className="waves-effect waves-light theme-btn light-blue darken-3 btn" type="button" name="action" onclick="openCamera();">Add a photo</button> --> */}
                  <small>
                    <i>(Please select one photo of less than 2MB)</i>
                  </small>
                </div>
              </div>
            </>
          )}
          <div className="row reports">
            {formType != "cs" && (
              <div className="report-section">
                <div className="report-row">
                  <p>Reported to staff </p>
                </div>
                <div className="report-value">
                  <div className="form-check value-margin">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="flexRadioDefault1"
                      id="isReported"
                      checked={payload.isReported === 1}
                      onChange={(e) => onChangeHandler(e, 1)}
                    />
                    <label className="form-check-label">Yes</label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="flexRadioDefault1"
                      id="isReported"
                      checked={payload.isReported === 0}
                      onChange={(e) => onChangeHandler(e, 0)}
                    />
                    <label className="form-check-label">No</label>
                  </div>
                </div>
                <div></div>
              </div>
            )}
            <div className="report-section">
              <div className="report-row">
                <p>Do you want to be kept updated about this ? </p>
              </div>
              <div className="report-value">
                <div className="form-check value-margin">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="flexRadioDefault"
                    id="isUpdated"
                    checked={payload.isUpdated === 1}
                    onChange={(e) => onChangeHandler(e, 1)}
                  />
                  <label className="form-check-label">Yes</label>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="flexRadioDefault"
                    id="isUpdated"
                    checked={payload.isUpdated === 0}
                    onChange={(e) => onChangeHandler(e, 0)}
                  />
                  <label className="form-check-label">No</label>
                </div>
              </div>
              <div></div>
            </div>
          </div>
          {payload.isUpdated == 1 && (
            <>
              <div className="row form-inputs">
                <div className="col-md-12 mb-4">
                  <small className="mandatory">*</small>
                  <input
                    type="text"
                    className="c-input"
                    placeholder="Name"
                    name="name"
                    id="name"
                    value={payload.name}
                    onChange={onChangeHandler}
                  />
                  <span
                    className="error-message"
                    style={{ float: "left", marginRight: "15px" }}
                  ></span>
                  {validationCheck.name && (
                    <span className="error-message">
                      Please enter your name.
                    </span>
                  )}
                </div>
              </div>

              <div className="row form-inputs">
                <div className="report-value">
                  <div className="col-md-12 mb-4">
                    <div className="form-check value-margin">
                      <input
                        className="form-check-input radio-btn"
                        type="radio"
                        name="flexRadioDefault3"
                        id="mobileNumberCheckBox"
                        onChange={onChangeHandler}
                        checked={payload.isMobileSelected}
                      />
                      <label className="form-check-label">
                        <small className="mandatory">*</small>
                        <input
                          maxLength="11"
                          id="mobileNumber"
                          pattern={"[1-9]{1}[0-9]{10}"}
                          className={
                            !payload.isMobileSelected
                              ? "validate c-input disble-input"
                              : "validate c-input"
                          }
                          placeholder="Mobile number"
                          name="mobileNumber"
                          value={payload.mobileNumber}
                          onChange={onChangeHandler}
                          disabled={!payload.isMobileSelected}
                        />

                        <span className="error-message align-error"></span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row form-inputs">
                <div className="col-md-12">
                  <div className="form-check">
                    <input
                      className="form-check-input radio-btn"
                      type="radio"
                      name="flexRadioDefault3"
                      id="emailCheckBox"
                      onChange={onChangeHandler}
                      checked={payload.isEmailSelected}
                    />
                    <label className="form-check-label">
                      <small className="mandatory">*</small>
                      <input
                        id="email"
                        value={payload.email}
                        type="email"
                        className={
                          !payload.isEmailSelected
                            ? "validate c-input disble-input"
                            : "validate c-input"
                        }
                        placeholder="Email address"
                        name="email"
                        onChange={onChangeHandler}
                        disabled={!payload.isEmailSelected}
                      />
                      <span className="error-message align-error"></span>
                      {validationCheck.email && (
                        <span className="error-message align-error">
                          please enter email
                        </span>
                      )}
                    </label>
                  </div>
                </div>
              </div>
            </>
          )}
          <div className="row form-btns mt-3">
            <div className="col-6 station-btn">
              <button
                className="waves-effect waves-light theme-btn light-blue darken-3 btn col s12"
                type="button"
                onClick={() => onSubmitHandler()}
              >
                Submit
              </button>
            </div>
            <div className="col-6 station-btn1">
              <button
                onClick={onClearHandler}
                className="waves-effect waves-light theme-btn  grey darken-2 btn col s12 clear-btn"
                type="button"
              >
                Clear
              </button>
            </div>
          </div>
        </form>
      </div>

      {isShowErrorModal && (
        <div
          className="modal d-block modal-background"
          id="detailModal"
          tabIndex="-1"
          aria-labelledby="detailModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog warning-modal">
            <div className="modal-content">
              <div className="warning-icon" id="success-icon">
                <i className="fa fa-exclamation-circle"></i>
              </div>
              <div className="modal-body m-0 p-0">
                <p className="m-0 p-0 war-content">
                  Please enter a number or email to be kept updated, or select
                  No if you do not wish updates.
                </p>
              </div>
              <div className="col s6 text-center">
                <button
                  className="waves-effect waves-light theme-btn light-blue darken-3 
              btn col s12 ok-btn war-modal-btn"
                  type="button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => setIsShowErrorModal(false)}
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {!isEmpty(responseData) && (
        <div id="modal1" className="modal modal-open">
          <div className="modal-content modal-content-body">
            {responseData.statusCode == 200 ? (
              <div className="success-icon" id="success-icon">
                <i className="fa fa-check-circle"></i>
              </div>
            ) : (
              <div
                className="alert-icon"
                id="error-icon"
                style={{ display: "block" }}
              >
                <i className="fa fa-exclamation-circle"></i>
              </div>
              // <div className="alert-icon" id="error-icon">
              //   <i className="material-icons">error_outline</i>
              // </div>
            )}
            <div align="center">
              {responseData?.body?.message && (
                <div id="modalMessage">
                  {responseData.statusCode == 200 && <h4>Thank You</h4>}
                  <br />
                  {responseData.body.message}
                  <br />
                  <div className="modal-line">
                    ----------------------------------
                  </div>
                  {formType !== "cs" && responseData.statusCode == 200 && (
                    <>
                      <h5 className="modal-number">Reference number</h5>
                      <h5 className="modal-number2">
                        {responseData.body.refNumber}
                      </h5>{" "}
                    </>
                  )}
                </div>
              )}
              <div className="col s6">
                <button
                  className="waves-effect waves-light theme-btn light-blue darken-3 btn col s12 ok-btn"
                  onClick={onResponeModalHandler}
                  type="button"
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
